module.exports = __webpack_public_path__ + "static/media/mobile-menu.184c03f5.svg";